import { render, staticRenderFns } from "./profilePopup.vue?vue&type=template&id=2f40f004&scoped=true&"
import script from "./profilePopup.vue?vue&type=script&lang=js&"
export * from "./profilePopup.vue?vue&type=script&lang=js&"
import style0 from "./profilePopup.vue?vue&type=style&index=0&id=2f40f004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40f004",
  null
  
)

export default component.exports